import { render, staticRenderFns } from "./OrganizationManage.vue?vue&type=template&id=ba0d539e&scoped=true&"
import script from "./OrganizationManage.vue?vue&type=script&lang=js&"
export * from "./OrganizationManage.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationManage.vue?vue&type=style&index=0&id=ba0d539e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0d539e",
  null
  
)

export default component.exports